module.exports = __webpack_public_path__ + "media/2.5b639e65.mp3";